import React from 'react'
import styled from 'styled-components'

import { Heading2, Heading4 } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Subheading = styled(Heading4)`
  margin-top: 32px;
  margin-bottom: 32px;
`

const CustomTextarea = styled.textarea`
  width: 100%;
  padding: 16px;
  border: 2px solid #d6d1eb;
  border-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 172%;
  color: #7f7fa3;
  outline: none;
  ::placeholder {
    color: #7f7fa3;
  }
  :focus-visible {
    border: 2px solid #5f30e2;
  }
  ${(p) => p.selected && 'border: 2px solid #5F30E2;'}
  ${(p) => p.error && 'border: 2px solid #F11B1B !important;'}
`

const ErrorMessage = styled.p`
  margin-top: 8px;
  color: #f11b1b;
`

const Textarea = () => {
  return (
    <>
      <Heading>Text area</Heading>
      <Subheading>Default</Subheading>
      <CustomTextarea placeholder="How can we help" />
      <Subheading>Selected</Subheading>
      <CustomTextarea placeholder="How can we help" selected />
      <Subheading>Error</Subheading>
      <CustomTextarea placeholder="How can we help" error />
      <ErrorMessage>Please enter your “heading here”</ErrorMessage>
    </>
  )
}

export default Textarea
